export const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY || '';

// Note: After generating VAPID keys in Laravel, add the public key to:
// 1. .env file as REACT_APP_VAPID_PUBLIC_KEY=your_key_here
// 2. Or directly replace the empty string above with your public key
